import { AxiosInstance, AxiosResponse } from 'axios';
import { SubscriptionCreateDto } from './inputs/subscription.input';
import { SubscriptionResponse } from './responses/subscription.response';

export class SubscriptionsModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async verifyEmail(dto: SubscriptionCreateDto): Promise<AxiosResponse<SubscriptionResponse>> {
    return await this.client.post('/subscriptions/', dto);
  }

  async subscribeEmail(encodedEmail: string): Promise<AxiosResponse<SubscriptionResponse>> {
    return await this.client.get(`/subscriptions/add/${encodedEmail}`);
  }

  async unsubscribeEmail(encodedEmail: string): Promise<AxiosResponse<SubscriptionResponse>> {
    return await this.client.get(`/subscriptions/remove/${encodedEmail}`);
  }
}
